var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Styled from "./saved-systems.style";
import { ImageSelectContainer } from "ui/components/elements/input/image-select/image-select-container";
import { CustomImageSelect } from "ui/components/elements/input/image-select";
import { FolderIcon } from "ui/components/elements/icons/folder";
import { filterSystemsByApplication, filterSystemsByName, getFolderPath, } from "store/user/util";
export var SavedSystemsSearchResults = function (_a) {
    var systems = _a.systems, folders = _a.folders, query = _a.query, selectedApplication = _a.selectedApplication, onOpen = _a.onOpen, onShowInFolder = _a.onShowInFolder;
    var t = useTranslation().t;
    var _b = __read(useState(""), 2), selectedId = _b[0], setSelectedId = _b[1];
    var results = useMemo(function () {
        // An empty name query doesn't restrict by name, so filtering by
        // application alone still yields results.
        var byName = query.trim().length > 0 ? filterSystemsByName(systems, query) : systems;
        return filterSystemsByApplication(byName, selectedApplication).sort(function (a, b) {
            return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
        });
    }, [systems, query, selectedApplication]);
    var onConfirm = useCallback(function (id) {
        var system = results.find(function (s) { return s.id === id; });
        if (system)
            onOpen(system);
    }, [results, onOpen]);
    var menuActions = useMemo(function () {
        return results.map(function (system) { return [
            {
                label: t("home-menu.saved-systems.open"),
                onClick: function () { return onOpen(system); },
            },
            {
                label: t("home-menu.saved-systems.show-in-folder"),
                onClick: function () { return onShowInFolder(system); },
            },
        ]; });
    }, [results, t, onOpen, onShowInFolder]);
    var rootFolderName = t("home-menu.saved-systems.root-folder");
    if (results.length === 0) {
        return (_jsx(Styled.EmptyText, { children: t("home-menu.saved-systems.no-results") }));
    }
    return (_jsx(ImageSelectContainer, { children: _jsx(CustomImageSelect, { value: selectedId, items: results.map(function (system) { return system.id; }), itemLabels: results.map(function (system) { return system.name; }), itemDescriptions: results.map(function (system) { return (_jsxs(Styled.FolderPath, { children: [_jsx(FolderIcon, {}), getFolderPath(system.folderId, folders, rootFolderName)] }, system.id)); }), itemImages: results.map(function (system) { return system.imageSrc; }), onValueChange: setSelectedId, onConfirmChoice: onConfirm, withConfirmButton: true, menuActions: menuActions }) }));
};
